/**-----------------------------------------------------------------------------------------
* Copyright © 2021 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the project root for more information
*-------------------------------------------------------------------------------------------*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
var kendo_angular_l10n_1 = require("@progress/kendo-angular-l10n");
var messages_1 = require("./messages");
/**
 * @hidden
 *
 * Custom component messages override default component messages.
 */
var TimeSelectorCustomMessagesComponent = /** @class */ (function (_super) {
    tslib_1.__extends(TimeSelectorCustomMessagesComponent, _super);
    function TimeSelectorCustomMessagesComponent(service) {
        var _this = _super.call(this) || this;
        _this.service = service;
        return _this;
    }
    TimeSelectorCustomMessagesComponent_1 = TimeSelectorCustomMessagesComponent;
    Object.defineProperty(TimeSelectorCustomMessagesComponent.prototype, "override", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    var TimeSelectorCustomMessagesComponent_1;
    TimeSelectorCustomMessagesComponent = TimeSelectorCustomMessagesComponent_1 = tslib_1.__decorate([
        core_1.Component({
            providers: [
                {
                    provide: messages_1.TimePickerMessages,
                    useExisting: core_1.forwardRef(function () { return TimeSelectorCustomMessagesComponent_1; }) // tslint:disable-line:no-forward-ref
                }
            ],
            selector: 'kendo-timeselector-messages',
            template: ""
        }),
        tslib_1.__metadata("design:paramtypes", [kendo_angular_l10n_1.LocalizationService])
    ], TimeSelectorCustomMessagesComponent);
    return TimeSelectorCustomMessagesComponent;
}(messages_1.TimePickerMessages));
exports.TimeSelectorCustomMessagesComponent = TimeSelectorCustomMessagesComponent;
